export default __webpack_public_path__ + "static/media/results_2nd.85cd78b7.jpg";